import React from 'react'
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { CSSTransition } from 'react-transition-group'

import './modal.sass'

const BODY_MODAL_CLASS = 'is-modal-opened'

export default class Modal extends React.Component {
  static propTypes = {
    className: PropTypes.string,
    children: PropTypes.node.isRequired,
    small: PropTypes.bool,
    medium: PropTypes.bool,
    black: PropTypes.bool,
    red: PropTypes.bool,
    white: PropTypes.bool,
    clear: PropTypes.bool,
    title: PropTypes.string,
    fixedHeight: PropTypes.bool, // min-height 440px and centered content
    footer: PropTypes.node,
    onClose: PropTypes.func,
  }

  static defaultProps = {
    className: '',
    small: false,
    medium: false,
    black: false,
    red: false,
    white: false,
    clear: false,
    title: null,
    fixedHeight: false,
    footer: null,
    onClose: null,
  }

  constructor(props) {
    super(props)
    // NOTE: cuz we can close one modal, then open another one, sometimes previous modal
    //       remove all artifacts.
    //       Quickfix, will find a better solution
    setTimeout(() => {
      this.removeModalArtifacts()
      this.container = document.createElement('div')
      this.container.classList.add('modal')
      document.body.appendChild(this.container)
      document.body.classList.add(BODY_MODAL_CLASS)
      this.forceUpdate()
    }, 50)
  }

  componentWillUnmount() {
    this.removeModalArtifacts()
  }

  removeModalArtifacts = () => {
    if (this.container && this.container.parentNode) document.body.removeChild(this.container)
    if (document.querySelector('.modal')) {
      document.body.removeChild(document.querySelector('.modal'))
    }
    document.body.classList.remove(BODY_MODAL_CLASS)
  }

  renderModal() {
    return (
      <>
        <CSSTransition timeout={250} in appear classNames="modal__overlay">
          <div
            key="overlay"
            className="modal__overlay"
            {...(this.props.onClose && { onClick: this.props.onClose })}
          />
        </CSSTransition>
        {/* FIXME: integrated-app - just quick fix for set global styles */}
        <div key="container" className="modal__container integrated-app">
          <CSSTransition timeout={250} in appear classNames="modal__window">
            <div
              className={classNames('modal__window', this.props.className, {
                '--small': this.props.small,
                '--medium': this.props.medium,
                '--black': this.props.black,
                '--red': this.props.red,
                '--clear': this.props.clear,
                '--white': this.props.white,
                '--fixed-height': this.props.fixedHeight,
              })}
            >
              {/* {this.props.onClose && (
                <Close className="modal__close" onClick={this.props.onClose} />
              )} */}
              {this.props.title && (
                <div className="modal__header">
                  <h2>{this.props.title}</h2>
                </div>
              )}
              <div className="modal__content">{this.props.children}</div>
              {this.props.footer && <div className="modal__footer">{this.props.footer}</div>}
            </div>
          </CSSTransition>
        </div>
      </>
    )
  }

  render() {
    if (!this.container) return null
    return ReactDOM.createPortal(this.renderModal(), this.container)
  }
}
